import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-200">
      <div className="mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-trophy-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                皇冠体育
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              亚洲领先的专业体育赛事投注平台，为您提供安全、稳定、高效的体育博彩服务体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门赛事</h4>
            <div className="flex flex-col gap-2">
              {[
                { to: '/category/football', label: '足球赛事' },
                { to: '/category/basketball', label: '篮球赛事' },
                { to: '/category/tennis', label: '网球赛事' },
                { to: '/category/esports', label: '电竞比赛' },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              {[
                { to: '/about', label: '关于我们' },
                { to: '/about#brand', label: '品牌介绍' },
                { to: '/about#credibility', label: '信誉保障' },
                { to: '/about#contact', label: '联系我们' },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系客服</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-400">
              <p>客服热线：400-888-9999</p>
              <p>服务时间：7×24小时</p>
              <p>邮箱：service@huangguan-sports.com</p>
              <div className="flex gap-3 mt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 皇冠体育官方平台 版权所有
          </p>
          <div className="flex gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}